import UserDataService, { UserData } from "src/function/UserDataService";
import useLogout from "../useLogout";
import errorNotify from "src/notifications/errorNotify";


const useFetchData = () => {
  const [logoutUser] = useLogout();


  const fetchUserData = async (): Promise<UserData> => {
    const request = await UserDataService.fetchData();

    if (!request.error) {
      return request.data as UserData
    } else {
      const updatedAccessToken = await UserDataService.updateAccessToken();

      if (!updatedAccessToken.error) {
        const getUserData = await UserDataService.fetchData();

        if (!getUserData.error) {
          return getUserData.data as UserData
        } else {
          errorNotify(getUserData.error);

          return {
            id: '',
            email: '',
            telegramId: null,
            stakingKey: '',
            p2pKey: ''
          }
        }
      } else {
        logoutUser();

        return {
          id: '',
          email: '',
          telegramId: null,
          stakingKey: '',
          p2pKey: ''
        }
      }
    }
  }

  return { fetchUserData }
}

export default useFetchData